module.exports = __webpack_public_path__ + "img/img_industries7.3f04bab3.jpg";